// Generated by CoffeeScript 1.12.7
var Container, ModuleNotFound, construct, getArguments, runFactory, throwNotFound;

ModuleNotFound = require('./ModuleNotFound');

getArguments = require('./get-arguments');

construct = function(c, args) {
  var F;
  F = (function() {
    function F() {
      c.apply(this, args);
    }

    return F;

  })();
  F.prototype = c.prototype;
  return new F();
};

runFactory = function(factory, args) {
  return factory.apply(null, args);
};

throwNotFound = function(name, parent) {
  throw new ModuleNotFound(name, parent);
};

module.exports = Container = (function() {
  function Container(conf, _parents) {
    if (conf == null) {
      conf = {};
    }
    this._parents = _parents != null ? _parents : [];
    this._modules = conf.modules || conf;
    this._registrations = {};
    this._instances = {};
  }

  Container.prototype.factory = function(name, func) {
    if (!(func instanceof Function)) {
      throw new Error('A factory must be a function');
    }
    return this._register('factory', name, func);
  };

  Container.prototype.value = function(name, value) {
    return this._register('value', name, value);
  };

  Container.prototype["class"] = function(name, constructor) {
    if (!(constructor instanceof Function)) {
      throw new TypeError('A constructor must be a function');
    }
    return this._register('class', name, constructor);
  };

  Container.prototype.spread = function(obj) {
    var k, results, v;
    results = [];
    for (k in obj) {
      v = obj[k];
      results.push(this.value(k, v));
    }
    return results;
  };

  Container.prototype.get = function(name) {
    var registeredAt;
    if (!this.isRegistered(name)) {
      throwNotFound(name);
    }
    registeredAt = this._registeredAt(name);
    if (registeredAt === 'local') {
      if (!this._isInstantiated(name)) {
        this._instantiate(name);
      }
      return this._instances[name];
    } else {
      return this._parents[registeredAt].get(name);
    }
  };

  Container.prototype._isInstantiated = function(name) {
    return Object.keys(this._instances).indexOf(name) !== -1;
  };

  Container.prototype._registeredAt = function(name) {
    var i, j, len, p, parentIndex, ref;
    if (this._registrations[name] != null) {
      return 'local';
    } else {
      ref = this._parents;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        p = ref[i];
        if (p._registeredAt(name) != null) {
          parentIndex = i;
        }
      }
      return parentIndex;
    }
  };

  Container.prototype.isRegistered = function(name) {
    return this._registeredAt(name) !== void 0;
  };

  Container.prototype.getRegistrations = function() {
    var all, p;
    if (this._parents.length === 0) {
      return this._registrations;
    }
    all = (function() {
      var j, len, ref, results;
      ref = this._parents;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        p = ref[j];
        results.push(p.getRegistrations());
      }
      return results;
    }).call(this);
    all.push(this._registrations);
    return all.reduce(function(acc, item) {
      Object.keys(item).forEach(function(key) {
        return acc[key] = item[key];
      });
      return acc;
    }, {});
  };

  Container.prototype.getArguments = function(name) {
    if (this._modules[name] != null) {
      return this._modules[name];
    } else {
      return getArguments(this._registrations[name].value);
    }
  };

  Container.prototype.loadAll = function() {
    var j, len, p, ref;
    ref = this._parents;
    for (j = 0, len = ref.length; j < len; j++) {
      p = ref[j];
      p.loadAll();
    }
    return Object.keys(this._registrations).forEach((function(_this) {
      return function(name) {
        if (!_this._isInstantiated(name)) {
          return _this._instantiate(name);
        }
      };
    })(this));
  };

  Container.prototype.shutdown = function() {
    var j, len, p, ref, results;
    Object.keys(this._instances).forEach((function(_this) {
      return function(key) {
        var ref;
        return (ref = _this._instances[key]) != null ? typeof ref.__amendShutdown === "function" ? ref.__amendShutdown() : void 0 : void 0;
      };
    })(this));
    ref = this._parents;
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      p = ref[j];
      results.push(p.shutdown());
    }
    return results;
  };

  Container.prototype._register = function(type, name, value) {
    return this._registrations[name] = {
      value: value,
      type: type
    };
  };

  Container.prototype._instantiate = function(name, parent) {
    var instance, module, type, value;
    module = this._registrations[name];
    if (module == null) {
      throwNotFound(name, parent);
    }
    type = module.type;
    value = module.value;
    instance = type === 'value' ? value : this._instantiateWithDependencies(name, value, type);
    this._instances[name] = instance;
    return instance;
  };

  Container.prototype._instantiateWithDependencies = function(name, value, type) {
    var args, dependencies;
    args = this.getArguments(name);
    dependencies = args.map((function(_this) {
      return function(depName) {
        var registeredAt;
        registeredAt = _this._registeredAt(depName);
        if (registeredAt === 'local') {
          if (_this._isInstantiated(depName)) {
            return _this._instances[depName];
          } else {
            return _this._instantiate(depName, name);
          }
        } else if (registeredAt != null) {
          return _this._parents[registeredAt].get(depName);
        } else {
          return throwNotFound(depName, name);
        }
      };
    })(this));
    if (type === 'factory') {
      return runFactory(value, dependencies);
    }
    if (type === 'class') {
      return construct(value, dependencies);
    }
  };

  return Container;

})();
